import { create } from 'zustand';

export type PaymentReason = 'NO_SUBSCRIPTION' | 'INSUFFICIENT_BALANCE';

interface BillingUiState {
  paymentBlock: { reason: PaymentReason } | null;
  setPaymentBlock: (value: { reason: PaymentReason }) => void;
  clearPaymentBlock: () => void;
  lowBalanceDismissed: boolean;
  dismissLowBalance: () => void;
}

export const useBillingUiStore = create<BillingUiState>((set) => ({
  paymentBlock: null,
  setPaymentBlock: (value) => set({ paymentBlock: value }),
  clearPaymentBlock: () => set({ paymentBlock: null }),
  lowBalanceDismissed: false,
  dismissLowBalance: () => set({ lowBalanceDismissed: true }),
}));
